import { API_ENVIRONMENT_STORAGE_KEY, ApiEnvironment } from '@/state';
import { RawConfig } from '@/bootstrap/config';
export { runtimeEnvironment } from '@/utils/runtimeEnvironment';
import { runtimeEnvironment } from '@/utils/runtimeEnvironment';

export const getApiEnvironment = (): ApiEnvironment => {
    return (sessionStorage.getItem(API_ENVIRONMENT_STORAGE_KEY) ||
        runtimeEnvironment()) as ApiEnvironment;
};

export const API_ENVIRONMENT_LABELS: Record<ApiEnvironment, string> = {
    localhost: 'localhost:8080',
    localhosteksport: 'localhost eksport',
    local: 'local',
    stm: 'STM',
    dev: 'UTV',
    test: 'TEST',
    prod: 'PROD',
    elvegutv: 'Elveg UTV',
    elvegtest: 'Elveg TEST',
    elvegprod: 'Elveg PROD',
};

export function getDocumentTitle(): string {
    const env = runtimeEnvironment();
    if (env === 'prod') return 'Vegkart';
    const label = API_ENVIRONMENT_LABELS[env as ApiEnvironment];
    return label ? `Vegkart - ${label}` : 'Vegkart';
}

const bundledConfigs = process.env.config as unknown as
    Record<string, Partial<RawConfig>> | undefined;

export const config = {
    ...bundledConfigs?.base,
    ...bundledConfigs?.[getApiEnvironment()],
    ...bundledConfigs?.override,
} as RawConfig;
